import _ from '../../util/underscore-wrapper';
import Time from '../../util/Time';
import BaseView from '../BaseView';
import hbs from 'handlebars-inline-precompile';

function getOption(callout, option) {
  return _.resultCtx(callout.options, option, callout) || _.result(callout, option);
}

function getTopClass(callout) {
  let klass = 'infobox clearfix infobox-' + getOption(callout, 'type');

  switch (getOption(callout, 'size')) {
  case 'standard':
    klass += '';
    break;
  case 'slim':
    klass += ' infobox-slim';
    break;
  case 'compact':
    klass += ' infobox-compact';
    break;
  case 'large':
    klass += ' infobox-md';
    break;
  }
  if (getOption(callout, 'dismissible')) {
    klass += ' infobox-dismiss';
  }
  return klass;
}

const events = {
  'click .infobox-dismiss-link': function (e) {
    e.preventDefault();
    this.$el.fadeOut(Time.UNLOADING_FADE, () => {
      this.trigger('dismissed');
      this.remove();
    });
  }
};
const template = hbs`
    {{#if dismissible}}
      <a data-se="dismiss-link" class="infobox-dismiss-link" title="Dismiss" href="#">
        <span data-se="icon" class="dismiss-icon"></span>
      </a>
    {{/if}}
    <span data-se="icon" class="icon {{icon}}"></span>
    {{#if title}}<h3 data-se="header">{{title}}</h3>{{/if}}
    {{#if subtitle}}<p data-se="sub-header">{{subtitle}}</p>{{/if}}
    {{#if bullets}}
      <ul data-se="list" class="bullets">
      {{#each bullets}}<li data-se="list-item">{{this}}</li>{{/each}}
      </ul>
    {{/if}}
  `;
const CalloutCallout = BaseView.extend(
  /** @lends src/views/components/Callout.prototype */ {
    attributes: {
      'data-se': 'callout'
    },

    /**
     * Custom HTML or view to inject to the callout
     * @type {String|Okta.View}
     */
    content: null,

    /**
     * Size of icon. options are standard, large, compact
     * @type {String}
     */
    size: 'standard',

    /**
     * Type of the callout. Valid values are: info, success, warning, error, tip
     * @type {String}
     */
    type: 'info',

    /**
     * Can the callout be dismissed
     * @type {Boolean}
     */
    dismissible: false,

    /**
     * Callout title
     * @type {String}
     */
    title: null,

    /**
     * Callout subtitle
     * @type {String}
     */
    subtitle: null,

    /**
     * Array of strings to render as bullet points
     * @type {Array}
     */
    bullets: null,

    /**
     * Fired after the callout is dismised - applies when
     * {@link module:Okta.internal.views.components.Callout|dismissible} is set to true
     * @event src/views/components/Callout#dismissed
     */

    constructor: function () {
      this.events = _.defaults(this.events || {}, events);

      BaseView.apply(this, arguments);

      this.$el.addClass(getTopClass(this));

      this.template = template;

      const content = getOption(this, 'content');

      if (content) {
        this.add(content);
      }
    },

    getTemplateData: function () {
      let icon = getOption(this, 'type');

      const size = getOption(this, 'size');
      if (icon === 'tip') {
        // css is inconsistent
        icon = 'light-bulb';
      }
      switch (size) {
      case 'slim':
        icon = '';
        break;
      case 'large':
        icon = [icon, '-', '24'].join('');
        break;
      default:
        icon = [icon, '-', '16'].join('');
      }
      return {
        icon,
        title: getOption(this, 'title'),
        subtitle: getOption(this, 'subtitle'),
        bullets: getOption(this, 'bullets'),
        dismissible: getOption(this, 'dismissible')
      };
    }
  }
);

/**
 * @class src/views/components/Callout
 * @extends module:Okta.View
 */

/**
 * @class module:Okta.internal.views.components.Callout
 */
export default /** @lends module:Okta.internal.views.components.Callout */ {
  /**
   * Creates a {@link src/views/components/Callout|Callout}.
   * @static
   * @param {Object} options
   * @param {String|Function} [options.size] Size of icon. options are standard, large, compact, slim
   * @param {String|Okta.View} [options.content] Custom HTML or view to inject to the callout
   * @param {String|Function} [options.title] Callout title
   * @param {String|Function} [options.subtitle] Callout subtitle
   * @param {Array|Function} [options.bullets] Array of strings to render as bullet points
   * @param {Boolean|Function} [options.dismissible] Can the callout be dismissed
   * @param {String|Function} [options.type] Callout type. Valid values are: info, success, warning, error, tip
   *
   * @return {src/views/components/Callout}
   */
  create: function (options) {
    return new CalloutCallout(options);
  }
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/components/Callout.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/components/Callout.js